import Button from "components/Elements/Button/Button";
import Icon from "components/Elements/Icon/Icon";
import MailRecipientsComponent from "components/Pages/Inbox/Mails/MailRecipientsComponent";
import { useContent } from "contexts/contentContext/contentContext";
import useMediaQueries from "hooks/useMediaQueries";

interface ShareLinkElementI {
  recipientsList: string[];
  handleShareClick: () => void;
}

const ShareLinkElement = ({
  recipientsList,
  handleShareClick,
}: ShareLinkElementI) => {
  const { getTextByKey } = useContent();
  const { mobileCondition } = useMediaQueries();
  return (
    <div className="upload-complete-sidebar-body-row">
      <div className="info">
        <div className="info-title">
          {recipientsList[0]
            ? `${getTextByKey("send-to-title")}:`
            : getTextByKey("mail-uploaded-as-link-text")}
        </div>
        <div className="info-value">
          {recipientsList[0] ? (
            <MailRecipientsComponent recipientsList={recipientsList} top={30} />
          ) : null}
        </div>
      </div>

      <Button className="action share-btn" onClick={handleShareClick}>
        <Icon
          name="share-solid"
          {...(!mobileCondition ? { blue: true } : { gray: true })}
        />
        {!mobileCondition ? getTextByKey("sidebar-share-header") : null}
      </Button>
    </div>
  );
};

export default ShareLinkElement;
